(function () {
  const DOT_COUNT_MOBILE = 4;
  const DESKTOP_MIN_WIDTH = 1251;

  function initCarrossel(dotsEl) {
    if (dotsEl.dataset.ecCarrosselInit === '1') return;

    const sliderId = dotsEl.dataset.sliderId;
    const slider = sliderId ? document.getElementById(sliderId) : null;
    if (!slider) return;

    const sliderComp = slider.closest('slider-component');
    if (!sliderComp) return;

    const buttonsWrap = dotsEl.closest('.ec-carrossel-buttons');
    if (!buttonsWrap) return;

    dotsEl.dataset.ecCarrosselInit = '1';

    const columnsDesktop = parseInt(dotsEl.dataset.columnsDesktop, 10) || DOT_COUNT_MOBILE;

    const prevBtn = buttonsWrap.querySelector('.ec-carrossel-arrow--prev');
    const nextBtn = buttonsWrap.querySelector('.ec-carrossel-arrow--next');

    const isDesktop = () => window.matchMedia('(min-width: ' + DESKTOP_MIN_WIDTH + 'px)').matches;
    const getDotCount = () => isDesktop() ? columnsDesktop : DOT_COUNT_MOBILE;

    const buildDots = () => {
      const count = getDotCount();
      if (dotsEl.childElementCount === count) return;
      dotsEl.innerHTML = '';
      for (let i = 0; i < count; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ec-carrossel-dot';
        btn.setAttribute('aria-label', 'Indicador ' + (i + 1));
        btn.addEventListener('click', () => goToDot(i));
        dotsEl.appendChild(btn);
      }
    };

    const goToDot = (dotIndex) => {
      const itemOffset = sliderComp.sliderItemOffset || 0;
      if (itemOffset <= 0) return;
      const count = getDotCount();
      const currentIndex = Math.round(slider.scrollLeft / itemOffset);
      const cycleStart = Math.floor(currentIndex / count) * count;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const targetLeft = Math.min((cycleStart + dotIndex) * itemOffset, maxScroll);
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    };

    const updateState = () => {
      buildDots();

      const count = getDotCount();
      const itemOffset = sliderComp.sliderItemOffset || 0;
      const currentIndex = itemOffset > 0 ? Math.round(slider.scrollLeft / itemOffset) : 0;
      const activeDot = ((currentIndex % count) + count) % count;

      Array.from(dotsEl.children).forEach((c, i) => {
        c.classList.toggle('active', i === activeDot);
      });

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const atStart = slider.scrollLeft <= 1;
      const atEnd = maxScroll > 0 && slider.scrollLeft >= maxScroll - 1;

      if (prevBtn) {
        prevBtn.style.visibility = isDesktop() && atStart ? 'hidden' : 'visible';
      }
      if (nextBtn) {
        nextBtn.style.visibility = isDesktop() && atEnd ? 'hidden' : 'visible';
      }
    };

    buildDots();

    let scrollEndTimer;
    const onScroll = () => {
      updateState();
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(updateState, 150);
    };

    slider.addEventListener('scroll', onScroll, { passive: true });
    slider.addEventListener('scrollend', updateState);
    sliderComp.addEventListener('slideChanged', updateState);

    const ro = new ResizeObserver(() => {
      buildDots();
      updateState();
    });
    ro.observe(sliderComp);
    ro.observe(slider);

    slider.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', updateState, { once: true });
    });

    window.addEventListener('resize', updateState);

    updateState();
    setTimeout(updateState, 100);
    setTimeout(updateState, 500);
  }

  const run = (root) => {
    (root || document).querySelectorAll('.ec-carrossel-dots[data-slider-id]').forEach(initCarrossel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (e) => run(e.target));
  document.addEventListener('recommendations:loaded', (e) => {
    setTimeout(() => run(e.target), 100);
  });
})();
